/**
 * USIPIC scene + frame renderer (extracted from poster configurator v1.8.3)
 */
(function () {
  'use strict';

  var USIPIC_FRAME_ASSET_BASE = 'https://www.usipic.net/Frame-type/';
  var USIPIC_FRAME_ASSET_TIME = '20260609';
  var _boot = null;
  var _sceneBgImageCache = Object.create(null);
  var _frameSlicesImageCache = Object.create(null);
  var _artworkImageCache = Object.create(null);

  /** Canvas (frameless) model codes — map to Gallery / Museum Wrap */
  var USIPIC_CANVAS_MODELS = ['C25', 'C75'];
  var USIPIC_FRAME_MODELS = [
    'F35', 'F36', 'F85', 'F66', 'F91', 'F92', 'F93', 'F94', 'F97', 'F98', 'L01', 'L02', 'L05',
  ];
  var USIPIC_WRAP_BY_MODEL = {
    C25: { wrap: 'gallery-1.5', wrapInch: 1.5 },
    C75: { wrap: 'museum-0.75', wrapInch: 0.75 }, 
  };
  /** Gallery Wrap 1.5" baseline for 3D preview edge depth. */
  var USIPIC_WRAP_PREVIEW_BASE_INCH = 1.5;
  var USIPIC_WRAP_PREVIEW_BASE_SIDE_RATIO = 0.075;
  var USIPIC_WRAP_PREVIEW_BASE_TILT_RATIO = 0.008;
  var USIPIC_WRAP_PREVIEW_DEPTH_SCALE = 0.55;
  var USIPIC_WRAP_SKELETON_MIN_MS = 280;

  function applyWrapPreviewDepthScale(boot) {
    if (!boot) return;
    var pct = Number(boot.wrapPreviewDepthPercent);
    if (!pct || pct <= 0) pct = 55;
    USIPIC_WRAP_PREVIEW_DEPTH_SCALE = Math.min(1.2, Math.max(0.25, pct / 100));
  }

  function wrapPreviewRatiosFromInches(wrapInch) {
    var inch = Number(wrapInch);
    if (!inch || inch <= 0) inch = USIPIC_WRAP_PREVIEW_BASE_INCH;
    var scale = inch / USIPIC_WRAP_PREVIEW_BASE_INCH;
    var depth = USIPIC_WRAP_PREVIEW_DEPTH_SCALE;
    return {
      sideRatio: USIPIC_WRAP_PREVIEW_BASE_SIDE_RATIO * scale * depth,
      tiltRatio: USIPIC_WRAP_PREVIEW_BASE_TILT_RATIO * scale * depth,
    };
  }

  function getWrapPreviewRatios(root) {
    if (root && root._wrapSideRatio != null && root._wrapTiltRatio != null) {
      return { sideRatio: root._wrapSideRatio, tiltRatio: root._wrapTiltRatio };
    }
    return wrapPreviewRatiosFromInches(USIPIC_WRAP_PREVIEW_BASE_INCH);
  }
  var USIPIC_FRAME_ASSET_BASE = 'https://www.usipic.net/Frame-type/';
  var USIPIC_FRAME_ASSET_TIME = '20260609';

  function appendFrameAssetTime(url) {
    if (!USIPIC_FRAME_ASSET_TIME) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'time=' + encodeURIComponent(USIPIC_FRAME_ASSET_TIME);
  }

  function frameAssetUrl(filename) {
    return appendFrameAssetTime(USIPIC_FRAME_ASSET_BASE + filename);
  }

  function sceneAssetUrl(filename) {
    return frameAssetUrl(filename);
  }

  function isCanvasModelCode(code) {
    return USIPIC_CANVAS_MODELS.indexOf(String(code || '').toUpperCase()) >= 0;
  }

  function isFrameModelCode(code) {
    return USIPIC_FRAME_MODELS.indexOf(String(code || '').toUpperCase()) >= 0;
  }

  function frameSlicesUrl(code) {
    return frameAssetUrl(String(code || 'F97').toUpperCase() + '-Slices.png');
  }

  function frameThumbUrl(code) {
    return frameAssetUrl(String(code || 'F97').toUpperCase() + '.png');
  }

  function ensureFrameThumbImg(container, code) {
    if (!container) return null;
    var model = String(code || 'F97').toUpperCase();
    var url = frameThumbUrl(model);
    var img = container.querySelector('.usipic-frame-thumb');
    if (!img) {
      img = document.createElement('img');
      img.className = 'usipic-frame-thumb';
      img.loading = 'lazy';
      var label = container.querySelector('.usipic-frame-option__label, .usipic-frame-trigger__label');
      if (label) container.insertBefore(img, label);
      else container.insertBefore(img, container.firstChild);
    }
    if (container.classList.contains('usipic-frame-option')) {
      img.width = 132;
      img.height = 88;
    } else {
      img.width = 48;
      img.height = 32;
    }
    img.src = url;
    img.alt = model;
    return img;
  }

  function initFrameThumbnails(root) {
    var frameTrigger = root.querySelector('#usipic-frame-trigger');
    var frameMenu = root.querySelector('#usipic-frame-menu');
    if (!frameMenu) return;
    frameMenu.querySelectorAll('.usipic-frame-option[data-model]').forEach(function (opt) {
      var model = opt.getAttribute('data-model');
      ensureFrameThumbImg(opt, model);
      if (model) opt.setAttribute('data-thumb-url', frameThumbUrl(model));
    });
    if (frameTrigger) {
      var selected = frameMenu.querySelector('.usipic-frame-option.is-selected')
        || frameMenu.querySelector('.usipic-frame-option[data-model="F97"]')
        || frameMenu.querySelector('.usipic-frame-option');
      ensureFrameThumbImg(frameTrigger, selected ? selected.getAttribute('data-model') : 'F97');
    }
  }

  /**
   * Framed Print — border thickness at reference print size (screen px).
   * Values are tuned for USIPIC_FRAME_BORDER_REF_SHORT_INCH (default 16″ short side).
   * L01/L02/L05: also set in sections/usipic-poster-configurator.liquid → frameBorderWidthPx (boot overrides these defaults at runtime).
   */
  var USIPIC_FRAME_BORDER_WIDTH_PX = {
    F35: 56,
    F36: 56,
    F85: 56,
    F66: 56,
    F91: 56,
    F92: 56,
    F93: 56,
    F94: 56,
    F97: 56,
    F98: 56,
    L01: 10,
    L02: 6,
    L05: 6,
  };
  var USIPIC_FRAME_BORDER_WIDTH_DEFAULT = 56;
  /** Short-side inches that USIPIC_FRAME_BORDER_WIDTH_PX values are calibrated for. */
  var USIPIC_FRAME_BORDER_REF_SHORT_INCH = 16;

  function getFrameBorderWidthPx(frameCode) {
    var code = String(frameCode || 'F97').toUpperCase();
    if (Object.prototype.hasOwnProperty.call(USIPIC_FRAME_BORDER_WIDTH_PX, code)) {
      return Math.max(1, Math.round(USIPIC_FRAME_BORDER_WIDTH_PX[code]));
    }
    return USIPIC_FRAME_BORDER_WIDTH_DEFAULT;
  }

  /** Map hardcoded base width → screen px for selected print size (inches). */
  function resolveFrameBorderWidthPx(frameCode, widthInch, heightInch) {
    var base = getFrameBorderWidthPx(frameCode);
    var wi = Number(widthInch);
    var hi = Number(heightInch);
    if (!wi || !hi || wi <= 0 || hi <= 0) return base;
    var ref = USIPIC_FRAME_BORDER_REF_SHORT_INCH;
    if (!ref || ref <= 0) return base;
    // Keep small-size previews from making the decorative frame visually oversized.
    var shortInch = Math.max(ref, Math.min(wi, hi));
    return Math.max(4, Math.round(base * ref / shortInch));
  }

  function mergeFrameBorderWidthsFromBoot(boot) {
    if (!boot || !boot.frameBorderWidthPx || typeof boot.frameBorderWidthPx !== 'object') return;
    Object.keys(boot.frameBorderWidthPx).forEach(function (key) {
      var n = Number(boot.frameBorderWidthPx[key]);
      if (!isNaN(n) && n > 0) USIPIC_FRAME_BORDER_WIDTH_PX[String(key).toUpperCase()] = Math.round(n);
    });
    if (boot.frameBorderRefShortInch != null) {
      var ref = Number(boot.frameBorderRefShortInch);
      if (!isNaN(ref) && ref > 0) USIPIC_FRAME_BORDER_REF_SHORT_INCH = ref;
    }
  }

  /** L-shaped frame models — floater / 镂空 layout in preview. */
  var USIPIC_L_FRAME_MODELS = ['L01', 'L02', 'L05'];

  function isLFrameModelCode(code) {
    return USIPIC_L_FRAME_MODELS.indexOf(String(code || '').toUpperCase()) >= 0;
  }

  /** L-frame float gap — 0 = artwork flush to molding (no mat / no 留白). */
  function getLFrameFloatGap(fw, artW, artH) {
    return 0;
  }
 
  function shrinkLFrameLayout(imgW, imgH, fw, maxW, maxH) {
    var gapW = getLFrameFloatGap(fw, imgW, imgH);
    var totalW = imgW + 2 * (fw + gapW);
    var totalH = imgH + 2 * (fw + gapW);
    if (totalW <= maxW && totalH <= maxH) {
      return { imgW: imgW, imgH: imgH, fw: fw, gapW: gapW, totalW: totalW, totalH: totalH };
    }
    var shrink = Math.min(maxW / totalW, maxH / totalH, 1);
    if (shrink >= 0.999) {
      return { imgW: imgW, imgH: imgH, fw: fw, gapW: gapW, totalW: totalW, totalH: totalH };
    }
    return shrinkLFrameLayout(
      Math.max(1, Math.round(imgW * shrink)),
      Math.max(1, Math.round(imgH * shrink)),
      Math.max(1, Math.round(fw * shrink)),
      maxW,
      maxH
    );
  }

  function _drawLFrameFloatRecess(ctx, ox, oy, fw, totalW, totalH) {
    var innerL = ox + fw;
    var innerT = oy + fw;
    var innerW = totalW - 2 * fw;
    var innerH = totalH - 2 * fw;
    if (innerW <= 0 || innerH <= 0) return;

    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(innerL, innerT, innerW, innerH);
    ctx.restore();
  }

  function _drawFloatedArtwork(ctx, userImg, artX, artY, imgW, imgH, gapW, pan) {
    ctx.save();
    if (gapW > 0) {
      ctx.shadowColor = 'rgba(0,0,0,0.10)';
      ctx.shadowBlur = Math.max(1, Math.round(gapW * 0.35));
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = Math.max(1, Math.round(gapW * 0.12));
    }
    _drawCoverImage(ctx, userImg, artX, artY, imgW, imgH, pan);
    ctx.restore();
  }

  function _drawCoverImage(ctx, img, x, y, w, h, pan) {
    if (!img || !w || !h) return;
    pan = pan || { x: 50, y: 50 };
    var iw = img.naturalWidth || img.width;
    var ih = img.naturalHeight || img.height;
    if (!iw || !ih) return;
    var destAR = w / h;
    var srcAR = iw / ih;
    var sw, sh;
    if (srcAR > destAR) {
      sh = ih;
      sw = Math.round(ih * destAR);
    } else {
      sw = iw;
      sh = Math.round(iw / destAR);
    }
    sw = Math.max(1, Math.min(sw, iw));
    sh = Math.max(1, Math.min(sh, ih));
    var sx = Math.round((iw - sw) * (Math.max(0, Math.min(100, pan.x)) / 100));
    var sy = Math.round((ih - sh) * (Math.max(0, Math.min(100, pan.y)) / 100));
    ctx.drawImage(img, sx, sy, sw, sh, x, y, w, h);
  }

  function _makeCroppedArtSource(src, widthInch, heightInch, pan) {
    if (!src) return src;
    pan = pan || { x: 50, y: 50 };
    var iw = src.naturalWidth || src.width;
    var ih = src.naturalHeight || src.height;
    if (!iw || !ih) return src;
    var destAR = (widthInch || 8) / (heightInch || 10);
    var sw, sh;
    if (iw / ih > destAR) {
      sh = ih;
      sw = Math.round(ih * destAR);
    } else {
      sw = iw;
      sh = Math.round(iw / destAR);
    }
    sw = Math.max(1, Math.min(sw, iw));
    sh = Math.max(1, Math.min(sh, ih));
    var sx = Math.round((iw - sw) * (Math.max(0, Math.min(100, pan.x)) / 100));
    var sy = Math.round((ih - sh) * (Math.max(0, Math.min(100, pan.y)) / 100));
    var tc = document.createElement('canvas');
    tc.width = sw;
    tc.height = sh;
    tc.getContext('2d').drawImage(src, sx, sy, sw, sh, 0, 0, sw, sh);
    return tc;
  }

  // 鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€
  /**
   * Full {code}-Slices.png strip — no corner cropping; entire asset is the edge profile.
   */
  function getFrameSliceMetrics(slicesImg) {
    var iw = slicesImg && slicesImg.naturalWidth ? slicesImg.naturalWidth : 140;
    var ih = slicesImg && slicesImg.naturalHeight ? slicesImg.naturalHeight : 1008;
    return {
      midSrcX: 0,
      midSrcY: 0,
      midSrcW: iw,
      midSrcH: ih,
    };
  }

  //  Frame preview …9-slice compositing with {frameCode}-Slices.png
  //
  //  The Slices.png is a 9-slice image:
  //
  //    鈹屸攢鈹€鈹€鈹€鈹€鈹€鈹攢鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹攢鈹€鈹€鈹€鈹€鈹€鈹?
  //    鈹? TL  鈹?    TOP      鈹? TR  鈹? ->?corner size = slice (auto-detected)
  //    鈹溾攢鈹€鈹€鈹€鈹€鈹€鈹尖攢鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹尖攢鈹€鈹€鈹€鈹€鈹€鈹?
  //    鈹? L   鈹? (center)    鈹? R   鈹? ->?stretched to fit
  //    鈹溾攢鈹€鈹€鈹€鈹€鈹€鈹尖攢鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹尖攢鈹€鈹€鈹€鈹€鈹€鈹?
  //    鈹? BL  鈹?   BOTTOM    鈹? BR  鈹?
  //    鈹斺攢鈹€鈹€鈹€鈹€鈹€鈹粹攢鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹粹攢鈹€鈹€鈹€鈹€鈹€鈹?
  //
  //  Corner size is detected as min(imageW, imageH) / 3 (equal thirds).
  //  The center region of the Slices.png may be any content …we draw
  //  the user's artwork over it, so only the border ring is visible.
  // 鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€

  /**
   * Draw frame border with 45掳 mitered corners (Python tile_edge_image equivalent).
   *
   * Each of the 4 sides is rendered as a tiled strip, then clipped to a
   * trapezoid so the four corners naturally form 45掳 miters where they meet.
   *
   * Source regions used from Slices.png (3-section layout: corner | mid | corner):
   *   Horizontal tile unit : middle top strip  (s, 0,  iw-2s, s)
   *   Vertical tile unit   : middle left strip (0, s,  s,  ih-2s)
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {HTMLImageElement} img       …the Slices.png
   * @param {object} metrics             …from getFrameSliceMetrics()
   * @param {number} fw                  …target frame width on screen
   * @param {number} ox, oy              …top-left of the total frame rect
   * @param {number} totalW, totalH      …outer dimensions
   */
  function _drawFrameSidesWithMiter(ctx, img, metrics, fw, ox, oy, totalW, totalH) {
    var midSrcX = metrics.midSrcX;
    var midSrcY = metrics.midSrcY;
    var midSrcW = metrics.midSrcW;
    var midSrcH = metrics.midSrcH;

    // LEFT / RIGHT — tile edge profile vertically
    var vTileH = Math.max(1, Math.round(midSrcH * fw / midSrcW));
    var vTileCvs = document.createElement('canvas');
    vTileCvs.width = fw; vTileCvs.height = vTileH;
    var vtc = vTileCvs.getContext('2d');
    vtc.drawImage(img, midSrcX, midSrcY, midSrcW, midSrcH, 0, 0, fw, vTileH);
    var vStripCvs = document.createElement('canvas');
    vStripCvs.width = fw; vStripCvs.height = totalH;
    var vsCx = vStripCvs.getContext('2d');
    for (var vy = 0; vy < totalH; vy += vTileH) {
      var vdh = Math.min(vTileH, totalH - vy);
      vsCx.drawImage(vTileCvs, 0, 0, fw, vdh, 0, vy, fw, vdh);
    }
    var vStrip = vStripCvs;

    // TOP / BOTTOM — rotate vertical tile 90° CW so profile matches side thickness
    var hTileW = vTileH;
    var hTileCvs = document.createElement('canvas');
    hTileCvs.width = hTileW; hTileCvs.height = fw;
    var htc = hTileCvs.getContext('2d');
    htc.save();
    htc.translate(hTileW, 0);
    htc.rotate(Math.PI / 2);
    htc.drawImage(vTileCvs, 0, 0);
    htc.restore();
    var hStripCvs = document.createElement('canvas');
    hStripCvs.width = totalW; hStripCvs.height = fw;
    var hsCx = hStripCvs.getContext('2d');
    for (var hx = 0; hx < totalW; hx += hTileW) {
      var hdw = Math.min(hTileW, totalW - hx);
      hsCx.drawImage(hTileCvs, 0, 0, hdw, fw, hx, 0, hdw, fw);
    }
    var hStrip = hStripCvs;

    // 鈹€鈹€ TOP …trapezoid: wide at outer edge, narrows inward 鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€
    //   outer: (ox, oy) ->?(ox+totalW, oy)
    //   inner: (ox+fw, oy+fw) ->?(ox+totalW-fw, oy+fw)
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(ox, oy);
    ctx.lineTo(ox + totalW, oy);
    ctx.lineTo(ox + totalW - fw, oy + fw);
    ctx.lineTo(ox + fw, oy + fw);
    ctx.closePath();
    ctx.clip();
    ctx.drawImage(hStrip, ox, oy);
    ctx.restore();

    // 鈹€鈹€ BOTTOM …same strip, flipped vertically 鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(ox + fw, oy + totalH - fw);
    ctx.lineTo(ox + totalW - fw, oy + totalH - fw);
    ctx.lineTo(ox + totalW, oy + totalH);
    ctx.lineTo(ox, oy + totalH);
    ctx.closePath();
    ctx.clip();
    ctx.save();
    ctx.translate(ox + totalW / 2, oy + totalH);
    ctx.scale(1, -1);
    ctx.drawImage(hStrip, -totalW / 2, 0);
    ctx.restore();
    ctx.restore();

    // 鈹€鈹€ LEFT …trapezoid: wide at outer edge, narrows inward 鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(ox, oy);
    ctx.lineTo(ox + fw, oy + fw);
    ctx.lineTo(ox + fw, oy + totalH - fw);
    ctx.lineTo(ox, oy + totalH);
    ctx.closePath();
    ctx.clip();
    ctx.drawImage(vStrip, ox, oy);
    ctx.restore();

    // 鈹€鈹€ RIGHT …same strip, flipped horizontally 鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€鈹€
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(ox + totalW, oy);
    ctx.lineTo(ox + totalW - fw, oy + fw);
    ctx.lineTo(ox + totalW - fw, oy + totalH - fw);
    ctx.lineTo(ox + totalW, oy + totalH);
    ctx.closePath();
    ctx.clip();
    ctx.save();
    ctx.translate(ox + totalW, oy + totalH / 2);
    ctx.scale(-1, 1);
    ctx.drawImage(vStrip, 0, -totalH / 2);
    ctx.restore();
    ctx.restore();
  }

  /** Shared frame layout — used by Preview overlay and room scenes (preview为准). */
  function computeFrameLayout(userImg, widthInch, heightInch, frameCode, maxW, maxH) {
    var fw = resolveFrameBorderWidthPx(frameCode, widthInch, heightInch);
    var estGap = isLFrameModelCode(frameCode) ? getLFrameFloatGap(fw, maxW, maxH) : 0;
    var sideInset = fw + estGap;
    var nw = (userImg && (userImg.naturalWidth || userImg.width)) || 1;
    var nh = (userImg && (userImg.naturalHeight || userImg.height)) || 1;
    var scale = Math.min(
      maxW / (nw + 2 * sideInset),
      maxH / (nh + 2 * sideInset)
    );
    if (!scale || scale <= 0 || !isFinite(scale)) scale = 1;

    var imgW = Math.round(nw * scale);
    var imgH = Math.round(nh * scale);
    if (isLFrameModelCode(frameCode)) {
      var lLayout = shrinkLFrameLayout(imgW, imgH, fw, maxW, maxH);
      return {
        fw: lLayout.fw,
        imgW: lLayout.imgW,
        imgH: lLayout.imgH,
        gapW: lLayout.gapW,
        totalW: lLayout.totalW,
        totalH: lLayout.totalH,
      };
    }
    return {
      fw: fw,
      imgW: imgW,
      imgH: imgH,
      gapW: 0,
      totalW: imgW + 2 * fw,
      totalH: imgH + 2 * fw,
    };
  }

  function paintFramedPiece(ctx, userImg, slicesImg, layout, ox, oy, pan) {
    if (!ctx || !userImg || !slicesImg || !layout) return;
    var metrics = getFrameSliceMetrics(slicesImg);
    var fw = layout.fw;
    var gapW = layout.gapW || 0;
    var totalW = layout.totalW;
    var totalH = layout.totalH;
    var artX = ox + fw + gapW;
    var artY = oy + fw + gapW;

    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,0.38)';
    ctx.shadowBlur = Math.round(fw * 0.5);
    ctx.shadowOffsetX = Math.round(fw * 0.06);
    ctx.shadowOffsetY = Math.round(fw * 0.10);
    ctx.fillStyle = '#fff';
    ctx.fillRect(ox, oy, totalW, totalH);
    ctx.restore();

    _drawFrameSidesWithMiter(ctx, slicesImg, metrics, fw, ox, oy, totalW, totalH);
    if (gapW > 0) {
      _drawLFrameFloatRecess(ctx, ox, oy, fw, totalW, totalH);
    }
    _drawFloatedArtwork(ctx, userImg, artX, artY, layout.imgW, layout.imgH, gapW, pan);
  }

  /** Offscreen framed piece at preview reference scale (same math as Preview mode). */
  function buildFramedArtCanvas(userImg, slicesImg, widthInch, heightInch, frameCode, maxW, maxH, pan) {
    if (!userImg || !slicesImg || !slicesImg.naturalWidth) return null;
    var layout = computeFrameLayout(userImg, widthInch, heightInch, frameCode, maxW, maxH);
    if (!layout.totalW || !layout.totalH) return null;
    var tc = document.createElement('canvas');
    tc.width = layout.totalW;
    tc.height = layout.totalH;
    paintFramedPiece(tc.getContext('2d'), userImg, slicesImg, layout, 0, 0, pan);
    tc._frameLayout = layout;
    return tc;
  }

  /** Main frame compositing using 9-slice Slices.png.
   * @param {number} [widthInch]  …selected print width in inches (e.g. 16)
   * @param {number} [heightInch] …selected print height in inches (e.g. 20)
   */
  /** Drop shadow pass + crisp redraw (frame preview canvas). */
  function _drawCanvasImageWithShadow(ctx, img, x, y) {
    if (!ctx || !img || !img.width) return;
    var minDim = Math.min(img.width, img.height);
    var blur = Math.max(6, Math.round(minDim * 0.032));
    ctx.save();
    ctx.shadowColor = 'rgba(15,23,42,0.22)';
    ctx.shadowBlur = blur;
    ctx.shadowOffsetX = Math.round(blur * 0.22);
    ctx.shadowOffsetY = Math.round(blur * 0.45);
    ctx.drawImage(img, x, y);
    ctx.restore();
    ctx.drawImage(img, x, y);
  }

  function _drawFrameComposite(outCanvas, userImg, slicesImg, widthInch, heightInch, frameCode) {
    var ctx = outCanvas.getContext('2d');
    var ow = outCanvas.width, oh = outCanvas.height;
    ctx.clearRect(0, 0, ow, oh);

    var PAD = 0.06;
    var maxW = Math.round(ow * (1 - 2 * PAD));
    var maxH = Math.round(oh * (1 - 2 * PAD));
    var framed = buildFramedArtCanvas(userImg, slicesImg, widthInch, heightInch, frameCode, maxW, maxH);
    if (!framed) return;
    var ox = Math.round((ow - framed.width) / 2);
    var oy = Math.round((oh - framed.height) / 2);
    _drawCanvasImageWithShadow(ctx, framed, ox, oy);
  }

  /** Fallback when Slices.png fails to load …simple solid border. */
  function _drawFrameFallback(outCanvas, userImg) {
    var ctx = outCanvas.getContext('2d');
    var ow = outCanvas.width, oh = outCanvas.height;
    var fw = Math.round(Math.min(ow, oh) * 0.08);
    ctx.clearRect(0, 0, ow, oh);

    var piece = document.createElement('canvas');
    piece.width = ow;
    piece.height = oh;
    var pc = piece.getContext('2d');
    pc.fillStyle = '#8a7a60';
    pc.fillRect(0, 0, ow, oh);
    pc.drawImage(userImg, fw, fw, ow - 2 * fw, oh - 2 * fw);

    var ox = Math.round((ow - piece.width) / 2);
    var oy = Math.round((oh - piece.height) / 2);
    _drawCanvasImageWithShadow(ctx, piece, ox, oy);
  }

  /**
   * Entry point: load user snapshot + frame strip, then composite.
   * @param {fabric.Canvas} fabricCanvas
   * @param {HTMLCanvasElement} outCanvas
   * @param {string} frameCode  e.g. "F93"
   */
  function renderFrameComposite(fabricCanvas, outCanvas, frameCode, widthInch, heightInch, done) {
    var dataUrl = captureFabricCanvasDataUrl(fabricCanvas, 0.92);
    if (!dataUrl) {
      if (typeof done === 'function') done(null);
      return;
    }
    var userImg = new Image();
    var stripImg = new Image();
    stripImg.crossOrigin = 'anonymous';
    var pending = 2;

    function onLoad() {
      if (--pending > 0) return;
      _drawFrameComposite(outCanvas, userImg, stripImg, widthInch, heightInch, frameCode);
      if (typeof done === 'function') done(outCanvas);
    }
    userImg.onload = onLoad;
    stripImg.onload = onLoad;
    stripImg.onerror = function () {
      _drawFrameFallback(outCanvas, userImg);
      if (typeof done === 'function') done(outCanvas);
    };
    userImg.src = dataUrl;
    stripImg.src = frameSlicesUrl(frameCode);
  }

  var SCENE_BLEND_DEFAULTS = {
    shadow: { ox: 0.008, oy: 0.016, blur: 0.030, alpha: 0.30 },
    contact: { strength: 0.14, height: 0.08 },
    light: { side: 'right', warm: 0.09, cool: 0.05 },
    highlight: { strength: 0.22, width: 0.005 }
  };

  var SCENE_DATA = [
    {
      id: 'scene01', label: 'Piano',
      thumb: sceneAssetUrl('scene01.jpg'),
      img: sceneAssetUrl('scene01.jpg'),
      placement: {
        cx: 0.52, cy: 0.28, maxW: 0.40, maxH: 0.38, refW: 24, refH: 30,
        shadow: { ox: -0.012, oy: 0.018, blur: 0.038, alpha: 0.36 },
        light: { side: 'right', warm: 0.10, cool: 0.06 },
        contact: { strength: 0.15, height: 0.07 }
      }
    },
    {
      id: 'scene02', label: 'Fireplace',
      thumb: sceneAssetUrl('scene02.jpg'),
      img: sceneAssetUrl('scene02.jpg'),
      placement: {
        cx: 0.50, cy: 0.27, maxW: 0.42, maxH: 0.42, refW: 24, refH: 30,
        shadow: { ox: 0.006, oy: 0.015, blur: 0.032, alpha: 0.28 },
        light: { side: 'left', warm: 0.07, cool: 0.04 },
        contact: { strength: 0.12, height: 0.08 }
      }
    },
    {
      id: 'scene03', label: 'Entry',
      thumb: sceneAssetUrl('scene03.jpg'),
      img: sceneAssetUrl('scene03.jpg'),
      placement: {
        cx: 0.52, cy: 0.30, maxW: 0.58, maxH: 0.46, refW: 24, refH: 30,
        shadow: { ox: 0.010, oy: 0.016, blur: 0.034, alpha: 0.32 },
        light: { side: 'left', warm: 0.09, cool: 0.05 },
        contact: { strength: 0.13, height: 0.08 }
      }
    },
    {
      id: 'scene04', label: 'Lounge',
      thumb: sceneAssetUrl('scene04.jpg'),
      img: sceneAssetUrl('scene04.jpg'),
      placement: {
        cx: 0.64, cy: 0.30, maxW: 0.34, maxH: 0.42, refW: 24, refH: 30,
        shadow: { ox: 0.010, oy: 0.016, blur: 0.034, alpha: 0.32 },
        light: { side: 'left', warm: 0.08, cool: 0.05 },
        contact: { strength: 0.13, height: 0.08 }
      }
    },
    {
      id: 'scene05', label: 'Bedroom',
      thumb: sceneAssetUrl('scene05.jpg'),
      img: sceneAssetUrl('scene05.jpg'),
      placement: {
        cx: 0.50, cy: 0.26, maxW: 0.38, maxH: 0.36, refW: 24, refH: 24,
        shadow: { ox: -0.010, oy: 0.016, blur: 0.034, alpha: 0.32 },
        light: { side: 'right', warm: 0.09, cool: 0.06 },
        contact: { strength: 0.14, height: 0.07 }
      }
    },
    {
      id: 'scene06', label: 'Sofa',
      thumb: sceneAssetUrl('scene06.jpg'),
      img: sceneAssetUrl('scene06.jpg'),
      placement: {
        cx: 0.50, cy: 0.27, maxW: 0.46, maxH: 0.38, refW: 24, refH: 30,
        shadow: { ox: 0.010, oy: 0.016, blur: 0.036, alpha: 0.30 },
        light: { side: 'left', warm: 0.09, cool: 0.06 },
        contact: { strength: 0.13, height: 0.08 }
      }
    }
  ];

  function isRoomSceneId(sceneId) {
    return /^scene\d+$/.test(String(sceneId || ''));
  }

  function findSceneById(sceneId) {
    for (var i = 0; i < SCENE_DATA.length; i++) {
      if (SCENE_DATA[i].id === sceneId) return SCENE_DATA[i];
    }
    return null;
  }

  function _sceneDrawMetrics(ow, oh, sceneImg) {
    var scaleX = ow / sceneImg.naturalWidth;
    var scaleY = oh / sceneImg.naturalHeight;
    var sc = Math.min(scaleX, scaleY);
    return {
      sceneDrawW: sceneImg.naturalWidth * sc,
      sceneDrawH: sceneImg.naturalHeight * sc,
      sceneDrawX: (ow - sceneImg.naturalWidth * sc) / 2,
      sceneDrawY: (oh - sceneImg.naturalHeight * sc) / 2,
    };
  }

  /** Cached room background — art layer repaints on top without redrawing scene JPG */
  function _getOrBuildSceneBgLayer(outCanvas, sceneImg, scene) {
    var ow = outCanvas.width;
    var oh = outCanvas.height;
    var key = scene.id + ':' + ow + 'x' + oh;
    if (outCanvas._usipicSceneBgKey === key && outCanvas._usipicSceneBgCanvas) {
      return outCanvas._usipicSceneBgCanvas;
    }
    var bg = document.createElement('canvas');
    bg.width = ow;
    bg.height = oh;
    var bctx = bg.getContext('2d');
    var m = _sceneDrawMetrics(ow, oh, sceneImg);
    bctx.drawImage(sceneImg, m.sceneDrawX, m.sceneDrawY, m.sceneDrawW, m.sceneDrawH);
    outCanvas._usipicSceneBgKey = key;
    outCanvas._usipicSceneBgCanvas = bg;
    return bg;
  }

  function renderSceneBackground(outCanvas, scene) {
    if (!outCanvas || !scene) return;
    _loadCachedImage(_sceneBgImageCache, scene.id, scene.img, function (sceneImg) {
      if (!sceneImg) return;
      var ctx = outCanvas.getContext('2d');
      var ow = outCanvas.width;
      var oh = outCanvas.height;
      var bg = _getOrBuildSceneBgLayer(outCanvas, sceneImg, scene);
      ctx.drawImage(bg, 0, 0, ow, oh);
    });
  }

  function _loadCachedImage(cache, key, src, cb) {
    var entry = cache[key];
    if (entry && entry.ready) {
      cb(entry.img);
      return;
    }
    if (entry && entry.failed) {
      cb(null);
      return;
    }
    if (!entry) {
      entry = { img: new Image(), ready: false, failed: false, pending: [] };
      entry.img.crossOrigin = 'anonymous';
      cache[key] = entry;
      entry.img.onload = function () {
        entry.ready = true;
        entry.pending.splice(0).forEach(function (fn) { fn(entry.img); });
      };
      entry.img.onerror = function () {
        entry.failed = true;
        entry.pending.splice(0).forEach(function (fn) { fn(null); });
      };
      entry.img.src = src;
    }
    entry.pending.push(cb);
  }

  function _mergeSceneBlend(placement) {
    var d = SCENE_BLEND_DEFAULTS;
    var s = (placement && placement.shadow) || {};
    var c = (placement && placement.contact) || {};
    var l = (placement && placement.light) || {};
    var h = (placement && placement.highlight) || {};
    return {
      shadow: {
        ox: s.ox != null ? s.ox : d.shadow.ox,
        oy: s.oy != null ? s.oy : d.shadow.oy,
        blur: s.blur != null ? s.blur : d.shadow.blur,
        alpha: s.alpha != null ? s.alpha : d.shadow.alpha
      },
      contact: {
        strength: c.strength != null ? c.strength : d.contact.strength,
        height: c.height != null ? c.height : d.contact.height
      },
      light: {
        side: l.side || d.light.side,
        warm: l.warm != null ? l.warm : d.light.warm,
        cool: l.cool != null ? l.cool : d.light.cool
      },
      highlight: {
        strength: h.strength != null ? h.strength : d.highlight.strength,
        width: h.width != null ? h.width : d.highlight.width
      }
    };
  }

  function _paintSceneContactShadow(ctx, x, y, w, h, contact) {
    var contactH = Math.max(2, Math.round(h * contact.height));
    var padX = Math.round(w * 0.03);
    var topY = y + h - Math.round(contactH * 0.55);
    var bottomY = y + h + Math.round(contactH * 0.45);
    var grad = ctx.createLinearGradient(0, topY, 0, bottomY);
    grad.addColorStop(0, 'rgba(0,0,0,0)');
    grad.addColorStop(0.45, 'rgba(0,0,0,' + (contact.strength * 0.55) + ')');
    grad.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.save();
    ctx.globalCompositeOperation = 'multiply';
    ctx.fillStyle = grad;
    ctx.fillRect(x - padX, topY, w + padX * 2, bottomY - topY);
    ctx.restore();
  }

  function _paintSceneLightOverlay(ctx, x, y, w, h, light) {
    var g;
    if (light.side === 'left') {
      g = ctx.createLinearGradient(x, 0, x + w, 0);
      g.addColorStop(0, 'rgba(255,220,160,' + light.warm + ')');
      g.addColorStop(1, 'rgba(0,0,0,' + light.cool + ')');
    } else {
      g = ctx.createLinearGradient(x, 0, x + w, 0);
      g.addColorStop(0, 'rgba(0,0,0,' + light.cool + ')');
      g.addColorStop(1, 'rgba(255,220,160,' + light.warm + ')');
    }
    ctx.save();
    ctx.globalCompositeOperation = 'multiply';
    ctx.fillStyle = g;
    ctx.fillRect(x, y, w, h);
    ctx.restore();
  }

  function _paintSceneEdgeHighlight(ctx, x, y, w, h, light, highlight) {
    if (!highlight.strength) return;
    var hw = Math.max(1, Math.round(w * highlight.width));
    var g;
    ctx.save();
    if (light.side === 'right') {
      g = ctx.createLinearGradient(x + w - hw, 0, x + w, 0);
      g.addColorStop(0, 'rgba(255,255,255,0)');
      g.addColorStop(1, 'rgba(255,255,255,' + highlight.strength + ')');
      ctx.fillStyle = g;
      ctx.fillRect(x + w - hw, y, hw, h);
    } else {
      g = ctx.createLinearGradient(x, 0, x + hw, 0);
      g.addColorStop(0, 'rgba(255,255,255,' + highlight.strength + ')');
      g.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = g;
      ctx.fillRect(x, y, hw, h);
    }
    ctx.restore();
  }

  function _paintSceneArtOnWall(ctx, x, y, w, h, artImage, blend, pan) {
    if (!artImage || !w || !h) return;
    var sh = blend.shadow;

    _paintSceneContactShadow(ctx, x, y, w, h, blend.contact);

    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,' + sh.alpha + ')';
    ctx.shadowBlur = Math.max(4, Math.round(w * sh.blur));
    ctx.shadowOffsetX = Math.round(w * sh.ox);
    ctx.shadowOffsetY = Math.round(h * sh.oy);
    _drawCoverImage(ctx, artImage, x, y, w, h, pan);
    ctx.restore();

    _paintSceneLightOverlay(ctx, x, y, w, h, blend.light);
    _paintSceneEdgeHighlight(ctx, x, y, w, h, blend.light, blend.highlight);
  }

  function _paintSceneComposite(ctx, ow, oh, sceneImg, scene, artSource, selectedSize, useFrame, slicesImg, frameCode, viewOpts) {
    viewOpts = viewOpts || {};
    var placementOffset = viewOpts.placementOffset || { dx: 0, dy: 0 };
    var artScale = typeof viewOpts.artScale === 'number' ? viewOpts.artScale : 1;
    var artPan = viewOpts.artPan || { x: 50, y: 50 };

    var outCanvas = ctx.canvas;
    var bgLayer = _getOrBuildSceneBgLayer(outCanvas, sceneImg, scene);
    ctx.drawImage(bgLayer, 0, 0, ow, oh);

    var m = _sceneDrawMetrics(ow, oh, sceneImg);
    var sceneDrawW = m.sceneDrawW;
    var sceneDrawH = m.sceneDrawH;
    var sceneDrawX = m.sceneDrawX;
    var sceneDrawY = m.sceneDrawY;

    var parts = (selectedSize || '8x10').split('x');
    var artW = parseInt(parts[0], 10) || 8;
    var artH = parseInt(parts[1], 10) || 10;
    var artAR = artW / artH;

    var p = scene.placement;
    var targetW = sceneDrawW * p.maxW * (artW / (p.refW || 30));
    var targetH = sceneDrawH * p.maxH * (artH / (p.refH || 24));

    var fitW, fitH;
    if (artAR >= targetW / targetH) { fitW = targetW; fitH = targetW / artAR; }
    else { fitH = targetH; fitW = targetH * artAR; }
    fitW = Math.round(fitW * artScale);
    fitH = Math.round(fitH * artScale);

    var centerX = sceneDrawX + (p.cx + (placementOffset.dx || 0)) * sceneDrawW;
    var centerY = sceneDrawY + (p.cy + (placementOffset.dy || 0)) * sceneDrawH;
    var artX = Math.round(centerX - fitW / 2);
    var artY = Math.round(centerY - fitH / 2);

    var artDrawX = artX;
    var artDrawY = artY;
    var artDrawW = fitW;
    var artDrawH = fitH;
    var finalArt = artSource;
    var blend = _mergeSceneBlend(p);

    if (useFrame && slicesImg && slicesImg.naturalWidth > 0) {
      var refPad = 0.06;
      var refMaxW = Math.round(ow * (1 - 2 * refPad));
      var refMaxH = Math.round(oh * (1 - 2 * refPad));
      var framedSource = _makeCroppedArtSource(artSource, artW, artH, artPan);
      var framedRef = buildFramedArtCanvas(framedSource, slicesImg, artW, artH, frameCode, refMaxW, refMaxH, artPan);
      if (framedRef && framedRef._frameLayout && framedRef._frameLayout.imgW > 0) {
        var fl = framedRef._frameLayout;
        var scale = Math.min(fitW / fl.imgW, fitH / fl.imgH);
        artDrawW = Math.round(framedRef.width * scale);
        artDrawH = Math.round(framedRef.height * scale);
        artDrawX = Math.round(centerX - artDrawW / 2);
        artDrawY = Math.round(centerY - artDrawH / 2);
        finalArt = framedRef;
      }
    }

    _paintSceneArtOnWall(ctx, artDrawX, artDrawY, artDrawW, artDrawH, finalArt, blend, useFrame ? null : artPan);
    return { x: artDrawX, y: artDrawY, w: artDrawW, h: artDrawH };
  }
  function loadArtworkImage(src, cb) {
    if (!src) { cb(null); return; }
    var key = String(src).slice(0, 200);
    _loadCachedImage(_artworkImageCache, key, src, cb);
  }

  function artSourceFromInput(artworkSource) {
    if (!artworkSource) return null;
    if (artworkSource instanceof HTMLImageElement && artworkSource.naturalWidth) return artworkSource;
    if (artworkSource instanceof HTMLCanvasElement && artworkSource.width) return artworkSource;
    return null;
  }

  function renderToCanvas(outCanvas, opts, done) {
    opts = opts || {};
    done = typeof done === 'function' ? done : function () {};
    if (!outCanvas) { done(false); return; }
    var scene = findSceneById(opts.sceneId || 'scene01');
    if (!scene) { done(false); return; }
    var selectedSize = opts.size || '10x8';
    var printType = opts.printType === 'frame' ? 'frame' : 'canvas';
    var frameCode = opts.frameCode || 'F97';
    var useFrame = printType === 'frame';

    function paintWithArt(artSource) {
      if (!artSource) {
        renderSceneBackground(outCanvas, scene);
        outCanvas._usipicArtBounds = null;
        done(false, null);
        return;
      }
      var renderKey = (outCanvas._usipicSceneRenderKey || 0) + 1;
      outCanvas._usipicSceneRenderKey = renderKey;
      function paintNow(sceneImg, slicesImg) {
        if (outCanvas._usipicSceneRenderKey !== renderKey || !sceneImg) return;
        var ow = outCanvas.width;
        var oh = outCanvas.height;
        var scratch = outCanvas._usipicScratchCanvas;
        if (!scratch) {
          scratch = document.createElement('canvas');
          outCanvas._usipicScratchCanvas = scratch;
        }
        if (scratch.width !== ow || scratch.height !== oh) {
          scratch.width = ow;
          scratch.height = oh;
        }
        var sctx = scratch.getContext('2d');
        var bounds = _paintSceneComposite(
          sctx,
          ow,
          oh,
          sceneImg,
          scene,
          artSource,
          selectedSize,
          useFrame,
          slicesImg,
          frameCode,
          {
            placementOffset: opts.placementOffset,
            artScale: opts.artScale,
            artPan: opts.artPan,
          }
        );
        var ctx = outCanvas.getContext('2d');
        ctx.drawImage(scratch, 0, 0, ow, oh);
        outCanvas._usipicArtBounds = bounds || null;
        done(true, outCanvas._usipicArtBounds);
      }
      _loadCachedImage(_sceneBgImageCache, scene.id, scene.img, function (sceneImg) {
        if (outCanvas._usipicSceneRenderKey !== renderKey) return;
        if (!sceneImg) {
          var ctxErr = outCanvas.getContext('2d');
          ctxErr.clearRect(0, 0, outCanvas.width, outCanvas.height);
          ctxErr.fillStyle = '#e8e8e8';
          ctxErr.fillRect(0, 0, outCanvas.width, outCanvas.height);
          done(false);
          return;
        }
        if (useFrame) {
          var fcode = frameCode || 'F97';
          _loadCachedImage(_frameSlicesImageCache, frameSlicesUrl(fcode), frameSlicesUrl(fcode), function (slicesImg) {
            paintNow(sceneImg, slicesImg);
          });
        } else {
          paintNow(sceneImg, null);
        }
      });
    }

    if (typeof opts.artworkSource === 'string') {
      loadArtworkImage(opts.artworkSource, function (img) { paintWithArt(img); });
      return;
    }
    var direct = artSourceFromInput(opts.artworkSource);
    if (direct) { paintWithArt(direct); return; }
    paintWithArt(null);
  }

  function init(bootstrap) {
    _boot = bootstrap || {};
    if (_boot.frameAssetBase) USIPIC_FRAME_ASSET_BASE = String(_boot.frameAssetBase).replace(/\/?$/, '/');
    if (_boot.frameAssetTime) USIPIC_FRAME_ASSET_TIME = String(_boot.frameAssetTime);
    mergeFrameBorderWidthsFromBoot(_boot);
    applyWrapPreviewDepthScale(_boot);
  }

  function getScenes() {
    return SCENE_DATA.map(function (s) {
      return { id: s.id, label: s.label, thumb: s.thumb, img: s.img };
    });
  }

  function parseSizeInches(sizeId) {
    var parts = String(sizeId || '8x10').split('x');
    return {
      w: parseInt(parts[0], 10) || 8,
      h: parseInt(parts[1], 10) || 10,
    };
  }

  function _wrapTriangle(ctx, img, sx0, sy0, sx1, sy1, sx2, sy2, dx0, dy0, dx1, dy1, dx2, dy2) {
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(dx0, dy0);
    ctx.lineTo(dx1, dy1);
    ctx.lineTo(dx2, dy2);
    ctx.closePath();
    ctx.clip();
    var det = (sx1 - sx0) * (sy2 - sy0) - (sx2 - sx0) * (sy1 - sy0);
    if (Math.abs(det) < 1e-8) { ctx.restore(); return; }
    var a = ((dx1 - dx0) * (sy2 - sy0) - (dx2 - dx0) * (sy1 - sy0)) / det;
    var b = ((dx2 - dx0) * (sx1 - sx0) - (dx1 - dx0) * (sx2 - sx0)) / det;
    var c = ((dy1 - dy0) * (sy2 - sy0) - (dy2 - dy0) * (sy1 - sy0)) / det;
    var d = ((dy2 - dy0) * (sx1 - sx0) - (dy1 - dy0) * (sx2 - sx0)) / det;
    var e = dx0 - a * sx0 - b * sy0;
    var f = dy0 - c * sx0 - d * sy0;
    ctx.transform(a, c, b, d, e, f);
    ctx.drawImage(img, 0, 0);
    ctx.restore();
  }

  function _drawQuadImg(ctx, img, TLx, TLy, TRx, TRy, BRx, BRy, BLx, BLy) {
    var w = img.naturalWidth || img.width || 1;
    var h = img.naturalHeight || img.height || 1;
    ctx.save();
    ctx.imageSmoothingEnabled = true;
    if (ctx.imageSmoothingQuality) ctx.imageSmoothingQuality = 'high';
    _wrapTriangle(ctx, img, 0, 0, w, 0, w, h, TLx, TLy, TRx, TRy, BRx, BRy);
    _wrapTriangle(ctx, img, 0, 0, w, h, 0, h, TLx, TLy, BRx, BRy, BLx, BLy);
    ctx.restore();
  }

  function paintCanvasWrapForExport(src, outCanvas, sideRatio, tiltRatio) {
    if (!src || !outCanvas) return false;
    sideRatio = sideRatio != null ? sideRatio : 0.14;
    tiltRatio = tiltRatio != null ? tiltRatio : 0.01;
    var iw = src.width || src.naturalWidth;
    var ih = src.height || src.naturalHeight;
    if (!iw || !ih) return false;
    var sideW = Math.round(iw * sideRatio);
    var tilt = Math.round(ih * tiltRatio);
    var padR = Math.round(iw * 0.06);
    var padB = Math.round(ih * 0.07);
    var nw = iw + sideW + padR;
    var nh = ih + padB;
    if (outCanvas.width !== nw || outCanvas.height !== nh) {
      outCanvas.width = nw;
      outCanvas.height = nh;
    }
    var ctx = outCanvas.getContext('2d');
    ctx.clearRect(0, 0, nw, nh);
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,0.28)';
    ctx.shadowBlur = Math.round(Math.min(iw, ih) * 0.035);
    ctx.shadowOffsetX = Math.round(iw * 0.018);
    ctx.shadowOffsetY = Math.round(ih * 0.028);
    ctx.fillStyle = 'rgba(255,255,255,0.004)';
    ctx.beginPath();
    ctx.moveTo(0, tilt);
    ctx.lineTo(iw, 0);
    ctx.lineTo(iw + sideW, tilt);
    ctx.lineTo(iw + sideW, ih - tilt);
    ctx.lineTo(iw, ih);
    ctx.lineTo(0, ih - tilt);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
    _drawQuadImg(ctx, src, 1, tilt, iw, 0, iw, ih, 1, ih - tilt);
    var strip = document.createElement('canvas');
    strip.width = sideW;
    strip.height = ih;
    var sc = strip.getContext('2d');
    sc.translate(sideW, 0);
    sc.scale(-1, 1);
    sc.drawImage(src, iw - sideW, 0, sideW, ih, 0, 0, sideW, ih);
    _drawQuadImg(ctx, strip, iw, 0, iw + sideW, tilt, iw + sideW, ih - tilt, iw, ih);
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(iw, 0);
    ctx.lineTo(iw + sideW, tilt);
    ctx.lineTo(iw + sideW, ih - tilt);
    ctx.lineTo(iw, ih);
    ctx.closePath();
    ctx.globalAlpha = 0.22;
    ctx.fillStyle = 'rgba(0,0,0,0.35)';
    ctx.fill();
    ctx.restore();
    return true;
  }

  function paintCanvasWrapFromSource(src, outCanvas, sideRatio, tiltRatio) {
    if (!src || !outCanvas) return false;
    sideRatio = sideRatio != null ? sideRatio : 0.14;
    tiltRatio = tiltRatio != null ? tiltRatio : 0.01;
    var iw = src.width || src.naturalWidth;
    var ih = src.height || src.naturalHeight;
    if (!iw || !ih) return false;
    var sideW = Math.round(iw * sideRatio);
    var tilt = Math.round(ih * tiltRatio);
    var padR = Math.round(iw * 0.06);
    var padB = Math.round(ih * 0.07);
    var nw = iw + sideW + padR;
    var nh = ih + padB;
    if (outCanvas.width !== nw || outCanvas.height !== nh) {
      outCanvas.width = nw;
      outCanvas.height = nh;
    }
    var ctx = outCanvas.getContext('2d');
    ctx.clearRect(0, 0, nw, nh);
    ctx.fillStyle = '#fafafa';
    ctx.fillRect(0, 0, nw, nh);
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,0.38)';
    ctx.shadowBlur = Math.round(Math.min(iw, ih) * 0.04);
    ctx.shadowOffsetX = Math.round(iw * 0.022);
    ctx.shadowOffsetY = Math.round(ih * 0.035);
    ctx.fillStyle = 'rgba(100,100,100,0.01)';
    ctx.beginPath();
    ctx.moveTo(0, tilt);
    ctx.lineTo(iw, 0);
    ctx.lineTo(iw + sideW, tilt);
    ctx.lineTo(iw + sideW, ih - tilt);
    ctx.lineTo(iw, ih);
    ctx.lineTo(0, ih - tilt);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
    _drawQuadImg(ctx, src, 1, tilt, iw, 0, iw, ih, 1, ih - tilt);
    var strip = document.createElement('canvas');
    strip.width = sideW;
    strip.height = ih;
    var sc = strip.getContext('2d');
    sc.translate(sideW, 0);
    sc.scale(-1, 1);
    sc.drawImage(src, iw - sideW, 0, sideW, ih, 0, 0, sideW, ih);
    _drawQuadImg(ctx, strip, iw, 0, iw + sideW, tilt, iw + sideW, ih - tilt, iw, ih);
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(iw, 0);
    ctx.lineTo(iw + sideW, tilt);
    ctx.lineTo(iw + sideW, ih - tilt);
    ctx.lineTo(iw, ih);
    ctx.closePath();
    ctx.globalAlpha = 0.50;
    ctx.fillStyle = '#000';
    ctx.fill();
    ctx.restore();
    return true;
  }

  function artSourceToCanvas(artSource, widthInch, heightInch, pan, maxDim) {
    maxDim = maxDim || 1200;
    var cropped = _makeCroppedArtSource(artSource, widthInch, heightInch, pan);
    if (!cropped) return null;
    var ar = widthInch / heightInch;
    var cw, ch;
    if (ar >= 1) {
      cw = maxDim;
      ch = Math.round(maxDim / ar);
    } else {
      ch = maxDim;
      cw = Math.round(maxDim * ar);
    }
    var tc = document.createElement('canvas');
    tc.width = cw;
    tc.height = ch;
    tc.getContext('2d').drawImage(cropped, 0, 0, cw, ch);
    return tc;
  }

  function _drawFrameCompositeExport(outCanvas, userImg, slicesImg, widthInch, heightInch, frameCode) {
    var ctx = outCanvas.getContext('2d');
    var ow = outCanvas.width;
    var oh = outCanvas.height;
    ctx.clearRect(0, 0, ow, oh);
    var PAD = 0.06;
    var maxW = Math.round(ow * (1 - 2 * PAD));
    var maxH = Math.round(oh * (1 - 2 * PAD));
    var framed = buildFramedArtCanvas(userImg, slicesImg, widthInch, heightInch, frameCode, maxW, maxH);
    if (!framed) return;
    var ox = Math.round((ow - framed.width) / 2);
    var oy = Math.round((oh - framed.height) / 2);
    ctx.drawImage(framed, ox, oy);
  }

  /** Frame or canvas-wrap preview for cart/checkout — no room scene background. */
  function renderDesignPreviewForExport(opts, done) {
    opts = opts || {};
    done = typeof done === 'function' ? done : function () {};
    var artworkSource = opts.artworkSource;
    if (!artworkSource) { done(null); return; }

    var size = parseSizeInches(opts.size);
    var printType = opts.printType === 'frame' ? 'frame' : 'canvas';
    var frameCode = opts.frameCode || 'F97';
    var wrapCode = opts.wrapCode || 'C25';
    var pan = opts.artPan || { x: 50, y: 50 };
    var transparentBg = opts.transparentBackground !== false;

    function paintWithArt(artSource) {
      if (!artSource) { done(null); return; }
      var cropped = _makeCroppedArtSource(artSource, size.w, size.h, pan);
      if (!cropped) { done(null); return; }

      if (printType === 'frame') {
        var outCanvas = document.createElement('canvas');
        outCanvas.width = 900;
        outCanvas.height = Math.round(900 * (size.h / size.w) * 1.18);
        var slicesUrl = frameSlicesUrl(frameCode);
        _loadCachedImage(_frameSlicesImageCache, slicesUrl, slicesUrl, function (slicesImg) {
          if (slicesImg && slicesImg.naturalWidth) {
            if (transparentBg) {
              _drawFrameCompositeExport(outCanvas, cropped, slicesImg, size.w, size.h, frameCode);
            } else {
              _drawFrameComposite(outCanvas, cropped, slicesImg, size.w, size.h, frameCode);
            }
          } else {
            _drawFrameFallback(outCanvas, cropped);
          }
          done(outCanvas);
        });
        return;
      }

      var artCanvas = artSourceToCanvas(artSource, size.w, size.h, pan, 720);
      if (!artCanvas) { done(null); return; }
      var wrapCanvas = document.createElement('canvas');
      var inch = wrapCode === 'C75' ? 0.75 : 1.5;
      var ratios = wrapPreviewRatiosFromInches(inch);
      if (transparentBg) {
        paintCanvasWrapForExport(artCanvas, wrapCanvas, ratios.sideRatio, ratios.tiltRatio);
      } else {
        paintCanvasWrapFromSource(artCanvas, wrapCanvas, ratios.sideRatio, ratios.tiltRatio);
      }
      done(wrapCanvas);
    }

    if (typeof artworkSource === 'string') {
      loadArtworkImage(artworkSource, paintWithArt);
      return;
    }
    paintWithArt(artSourceFromInput(artworkSource));
  }

  /** Cropped artwork only (no frame, no scene) for production reference. */
  function renderDesignCroppedForExport(opts, done) {
    opts = opts || {};
    done = typeof done === 'function' ? done : function () {};
    var artworkSource = opts.artworkSource;
    if (!artworkSource) { done(null); return; }
    var size = parseSizeInches(opts.size);
    var pan = opts.artPan || { x: 50, y: 50 };

    function paintWithArt(artSource) {
      var canvas = artSourceToCanvas(artSource, size.w, size.h, pan, 1400);
      done(canvas);
    }

    if (typeof artworkSource === 'string') {
      loadArtworkImage(artworkSource, paintWithArt);
      return;
    }
    paintWithArt(artSourceFromInput(artworkSource));
  }

  window.__USIPIC_SCENE_RENDERER__ = {
    init: init,
    getScenes: getScenes,
    getFrameThumbUrl: frameThumbUrl,
    getWrapRatios: function (wrapCode) {
      var inch = wrapCode === 'C75' ? 0.75 : 1.5;
      return wrapPreviewRatiosFromInches(inch);
    },
    frameSlicesUrl: frameSlicesUrl,
    renderToCanvas: renderToCanvas,
    renderDesignPreviewForExport: renderDesignPreviewForExport,
    renderDesignCroppedForExport: renderDesignCroppedForExport,
    loadArtworkImage: loadArtworkImage,
    SCENE_DATA: SCENE_DATA,
  };
})();
